import * as React from "react";
import {
  List, Datagrid, TextField, BooleanField, NumberField,
  Show, TabbedShowLayout, useListContext,
} from "react-admin";
import { Alert } from "@mui/material";
import { JsonField } from "../../components/JsonField";
import { ProReferenceInput } from "../../components/RelationAutocomplete";
import { FrDateField } from "../../components/FrDateField";
import { UserRefField } from "../../components/ui";

// Lecture seule : création / édition / suppression réservées au pro auteur
// côté backend (403 pour l'admin). Champs = QuestionnaireDTO. Liste par pro
// (GET /questionnaires/pro/{proId}, cf. resourceMap).
const filters = [
  <ProReferenceInput key="proId" source="proId" label="Professionnel" alwaysOn />,
];

const ProHint = () => {
  const { filterValues } = useListContext();
  if (filterValues?.proId) return null;
  return (
    <Alert severity="info" sx={{ m: 2 }}>
      Sélectionnez un professionnel pour afficher ses questionnaires.
    </Alert>
  );
};

export default {
  list: () => (
    <List filters={filters} empty={false}>
      <ProHint />
      <Datagrid rowClick="show" bulkActionButtons={false}>
        <TextField source="title" />
        <TextField source="description" />
        <NumberField locales="fr-FR" source="questionCount" label="Questions" />
        <NumberField locales="fr-FR" source="participantCount" label="Participants" />
        <BooleanField source="enabled" />
        <FrDateField source="createdAt" />
      </Datagrid>
    </List>
  ),
  show: () => (
    <Show>
      <TabbedShowLayout>
        <TabbedShowLayout.Tab label="Détails">
          <TextField source="title" />
          <TextField source="description" />
          <TextField source="howItWorks" label="Fonctionnement" />
          <UserRefField source="professionalId" label="Professionnel" />
          <TextField source="professionalFirstName" label="Prénom pro" />
          <TextField source="professionalLastName" label="Nom pro" />
          <BooleanField source="enabled" />
          <NumberField locales="fr-FR" source="questionCount" label="Questions" />
          <NumberField locales="fr-FR" source="participantCount" label="Participants" />
          <FrDateField source="createdAt" showTime />
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab label="Questions">
          <JsonField source="questions" label="Questions" />
        </TabbedShowLayout.Tab>
        <TabbedShowLayout.Tab label="Brut">
          <JsonField source="__all__" />
        </TabbedShowLayout.Tab>
      </TabbedShowLayout>
    </Show>
  ),
};
